// LegalFooter — minimal footer with links to all 8 legal pages.
// Mounted at the app root (App.js) so it shows on every page.
import { Link, useLocation } from 'react-router-dom';
import { LEGAL_NAV } from '../content/legal';

const HIDDEN_PATHS = ['/auth', '/forgot-password', '/reset-password', '/auctioneer-login'];

export default function LegalFooter() {
  const { pathname } = useLocation();
  // Don't show on auth pages — they have their own visual focus.
  if (HIDDEN_PATHS.some((p) => pathname.startsWith(p))) return null;
  // Hide on legal pages themselves (sidebar already provides nav).
  if (pathname.startsWith('/legal/')) return null;

  return (
    <footer
      data-testid="legal-footer"
      className="border-t border-gray-100 bg-white mt-12"
      style={{ fontFamily: "'Outfit', sans-serif" }}
    >
      <div className="max-w-6xl mx-auto px-6 py-6">
        <div className="flex flex-wrap gap-x-5 gap-y-2 justify-center text-[11px] text-gray-500">
          {LEGAL_NAV.map((item) => (
            <Link
              key={item.slug}
              to={`/legal/${item.slug}`}
              data-testid={`footer-${item.slug}`}
              className="hover:text-[#2B3A67]"
            >
              {item.label}
            </Link>
          ))}
        </div>
        <p className="text-center text-[10px] text-gray-400 mt-3">
          © {new Date().getFullYear()} Backyard Entertainment and Lifestyle Pvt. Ltd. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
